import { render } from "./MenuHomePrincipal.vue?vue&type=template&id=f3959796"
import script from "./MenuHomePrincipal.vue?vue&type=script&lang=js"
export * from "./MenuHomePrincipal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__